import { Injectable } from '@angular/core';
import {
  LanguageCode,
  LANGUAGES_CONSTANTS,
  SUPPORTED_LANGUAGES_CONSTANTS
} from '../../core/constants/languages.constants';
import {BehaviorSubject} from 'rxjs';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private currentLangSubject = new BehaviorSubject<LanguageCode>(this.getSavedLanguage());
  currentLang$ = this.currentLangSubject.asObservable();

  getSupportedLanguages() {
    return SUPPORTED_LANGUAGES_CONSTANTS;
  }

  getCurrentLanguage(): LanguageCode {
    return this.currentLangSubject.value;
  }

  changeLanguage(languageCode: LanguageCode): void {
    localStorage.setItem(LANGUAGES_CONSTANTS.LANGUAGEKEY, languageCode);
    this.currentLangSubject.next(languageCode);
  }

  private getSavedLanguage(): LanguageCode {
    const saved = localStorage.getItem(LANGUAGES_CONSTANTS.LANGUAGEKEY) as LanguageCode;
    const isValid = SUPPORTED_LANGUAGES_CONSTANTS.some(l => l.code === saved);

    return isValid ? saved : environment.defaultLanguageCode as LanguageCode;
  }
}
